import { configureStore, Tuple } from '@reduxjs/toolkit'
import promiseMiddleware from 'redux-promise'
import reducer from './reducer'
import AxiosMiddleware from './middleware/AxiosMiddleware'
import LoginMiddleware from './middleware/LoginMiddleware'
import { auth } from '../firebase'

// Automatically adds the thunk middleware and the Redux DevTools extension
const store = configureStore({
  // Automatically calls `combineReducers`
  reducer,
  middleware: () =>
    new Tuple(
      promiseMiddleware,
      AxiosMiddleware,
      LoginMiddleware
    ),
})

auth.onAuthStateChanged(async (user) => {
  console.log('onAuthStateChanged', user)
  const currentUser = auth.currentUser
  const idToken =
    currentUser != null ? await currentUser.getIdToken(true) : null
  console.log('IDTOKEN: ', idToken)
  store.dispatch({ type: 'AUTH_STATE_CHANGED', user, idToken })
})

export default store
